import React, { FC, useEffect, useState } from 'react';

import { css } from '@emotion/react';
import { useKeenSlider } from 'keen-slider/react';

import 'keen-slider/keen-slider.min.css';
import { colors } from 'src/styles/colors';
import { flex } from 'src/styles/utils';

interface CarouselProps {
  children: React.ReactNode;
  contentCount: number;
}

const dot = css`
  ${flex()};
`;

const active = css`
  background: ${colors.AnchorTagColor};
  border-radius: 2px;
  width: 14px;
`;

const button = css`
  background: ${colors.PrimaryWhiteColorAlpha70};
  height: 4px;
  width: 4px;
  margin: 0 3px 0 0;
  border: 0;
  border-radius: 50%;
  cursor: pointer;
`;

const keensliderWrapper = css`
  overflow: unset;
`;

interface CommonRailSettings {
  initial: number;
  range?: {
    min: number;
    max: number; // set thumbnails count here
    align: boolean;
  };
  renderMode: 'performance';
}

const commonRailSettings: CommonRailSettings = {
  initial: 0,
  renderMode: 'performance'
};

const BannerCarouselTray: FC<CarouselProps> = ({ children, contentCount }) => {
  const [currentSlide, setCurrentSlide] = React.useState(0);
  const [loaded, setLoaded] = useState(false);
  const [sliderRef, instanceRef] = useKeenSlider<HTMLDivElement>(
    {
      ...commonRailSettings,
      loop: true,
      slideChanged(slider) {
        setCurrentSlide(slider.track.details.rel);
      },
      created() {
        setLoaded(true);
      }
    },
    [
      (slider) => {
        let Interval: string | number | NodeJS.Timeout | undefined;
        function nextInterval() {
          clearInterval(Interval);
          Interval = setInterval(() => {
            slider.next();
          }, 4000);
        }
        slider.on('created', () => {
          if (contentCount > 1) {
            nextInterval();
          }
        });
        slider.on('slideChanged', nextInterval);
      }
    ]
  );

  useEffect(() => {
    instanceRef.current?.update();
  }, [instanceRef]);

  return (
    <div>
      <div>
        <div ref={sliderRef} className="keen-slider" css={keensliderWrapper}>
          {children}
        </div>
      </div>
      {loaded && instanceRef.current && contentCount > 1 && (
        <div css={dot}>
          {[
            ...Array(instanceRef.current.track.details.slides.length).keys()
          ].map((idx) => {
            return (
              <div
                key={idx}
                onClick={() => {
                  instanceRef.current?.moveToIdx(idx);
                }}
                css={[button, currentSlide === idx ? active : '']}></div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default BannerCarouselTray;
